import gcp from "./SkillSVG/gcp.svg";
import nodejs from "./SkillSVG/nodejs.svg";
import html from "./SkillSVG/html.svg";
import photoshop from "./SkillSVG/photoshop.svg";
import illustrator from "./SkillSVG/illustrator.svg";
import docker from "./SkillSVG/docker.svg";
import adobeXd from "./SkillSVG/adobe-xd.svg";
import afterEffects from "./SkillSVG/after-effects.svg";
import css from "./SkillSVG/css.svg";
import angular from "./SkillSVG/angular.svg";
import javascript from "./SkillSVG/javascript.svg";
import nextJS from "./SkillSVG/nextJS.svg";
import nuxtJS from "./SkillSVG/nuxtJS.svg";
import react from "./SkillSVG/react.svg";
import svelte from "./SkillSVG/svelte.svg";
import typescript from "./SkillSVG/typescript.svg";
import vue from "./SkillSVG/vue.svg";
import bootstrap from "./SkillSVG/bootstrap.svg";
import bulma from "./SkillSVG/bulma.svg";
import capacitorjs from "./SkillSVG/capacitorjs.svg";
import coffeescript from "./SkillSVG/coffeescript.svg";
import memsql from "./SkillSVG/memsql.svg";
import mongoDB from "./SkillSVG/mongoDB.svg";
import mysql from "./SkillSVG/mysql.svg";
import postgresql from "./SkillSVG/postgresql.svg";
import tailwind from "./SkillSVG/tailwind.svg";
import vitejs from "./SkillSVG/vitejs.svg";
import vuetifyjs from "./SkillSVG/vuetifyjs.svg";
import c from "./SkillSVG/c.svg";
import cplusplus from "./SkillSVG/cplusplus.svg";
import csharp from "./SkillSVG/csharp.svg";
import dart from "./SkillSVG/dart.svg";
import go from "./SkillSVG/go.svg";
import java from "./SkillSVG/java.svg";
import julia from "./SkillSVG/julia.svg";
import kotlin from "./SkillSVG/kotlin.svg";
import matlab from "./SkillSVG/matlab.svg";
import php from "./SkillSVG/php.svg";
import python from "./SkillSVG/python.svg";
import ruby from "./SkillSVG/ruby.svg";
import swift from "./SkillSVG/swift.svg";
import adobeaudition from "./SkillSVG/adobeaudition.svg";
import aws from "./SkillSVG/aws.svg";
import deno from "./SkillSVG/deno.svg";
import django from "./SkillSVG/django.svg";
import firebase from "./SkillSVG/firebase.svg";
import gimp from "./SkillSVG/gimp.svg";
import git from "./SkillSVG/git.svg";
import graphql from "./SkillSVG/graphql.svg";
import lightroom from "./SkillSVG/lightroom.svg";
import materialui from "./SkillSVG/materialui.svg";
import nginx from "./SkillSVG/nginx.svg";
import numpy from "./SkillSVG/numpy.svg";
import opencv from "./SkillSVG/opencv.svg";
import premierepro from "./SkillSVG/premierepro.svg";
import pytorch from "./SkillSVG/pytorch.svg";
import selenium from "./SkillSVG/selenium.svg";
import strapi from "./SkillSVG/strapi.svg";
import tensorflow from "./SkillSVG/tensorflow.svg";
import webix from "./SkillSVG/webix.svg";
import wordpress from "./SkillSVG/wordpress.svg";

import azure from "./SkillSVG/azure.svg";
import blender from "./SkillSVG/blender.svg";
import fastify from "./SkillSVG/fastify.svg";
import figma from "./SkillSVG/figma.svg";
import flutter from "./SkillSVG/flutter.svg";
import haxe from "./SkillSVG/haxe.svg";
import ionic from "./SkillSVG/ionic.svg";
import markdown from "./SkillSVG/markdown.svg";
import microsoftoffice from "./SkillSVG/microsoftoffice.svg";
import picsart from "./SkillSVG/picsart.svg";
import sketch from "./SkillSVG/sketch.svg";
import unity from "./SkillSVG/unity.svg";
import wolframalpha from "./SkillSVG/wolframalpha.svg";

import canva from "./SkillSVG/canva.svg";

export const skillsImage = (skill) => {
  const skillID = skill.toLowerCase();
  switch (skillID) {
    case "gcp":
      return gcp;
    case "node js":
      return nodejs;
    case "html":
      return html;
    case "photoshop":
      return photoshop;
    case "docker":
      return docker;
    case "illustrator":
      return illustrator;
    case "adobe xd":
      return adobeXd;
    case "after effects":
      return afterEffects;
    case "css":
      return css;
    case "angular":
      return angular;
    case "javascript":
      return javascript;
    case "next js":
      return nextJS;
    case "nuxt js":
      return nuxtJS;
    case "react":
      return react;
    case "svelte":
      return svelte;
    case "typescript":
      return typescript;
    case "vue":
      return vue;
    case "bootstrap":
      return bootstrap;
    case "bulma":
      return bulma;
    case "capacitorjs":
      return capacitorjs;
    case "coffeescript":
      return coffeescript;
    case "memsql":
      return memsql;
    case "mongodb":
      return mongoDB;
    case "mysql":
      return mysql;
    case "postgresql":
      return postgresql;
    case "tailwind":
      return tailwind;
    case "vitejs":
      return vitejs;
    case "vuetifyjs":
      return vuetifyjs;
    case "c":
      return c;
    case "c++":
      return cplusplus;
    case "c#":
      return csharp;
    case "dart":
      return dart;
    case "go":
      return go;
    case "java":
      return java;
    case "kotlin":
      return kotlin;
    case "julia":
      return julia;
    case "matlab":
      return matlab;
    case "php":
      return php;
    case "python":
      return python;
    case "ruby":
      return ruby;
    case "swift":
      return swift;
    case "adobe audition":
      return adobeaudition;
    case "aws":
      return aws;
    case "deno":
      return deno;
    case "django":
      return django;
    case "firebase":
      return firebase;
    case "gimp":
      return gimp;
    case "git":
      return git;
    case "graphql":
      return graphql;
    case "lightroom":
      return lightroom;
    case "materialui":
      return materialui;
    case "nginx":
      return nginx;
    case "numpy":
      return numpy;
    case "opencv":
      return opencv;
    case "premiere pro":
      return premierepro;
    case "pytorch":
      return pytorch;
    case "selenium":
      return selenium;
    case "strapi":
      return strapi;
    case "tensorflow":
      return tensorflow;
    case "webix":
      return webix;
    case "wordpress":
      return wordpress;
    case "azure":
      return azure;
    case "blender":
      return blender;
    case "fastify":
      return fastify;
    case "figma":
      return figma;
    case "flutter":
      return flutter;
    case "haxe":
      return haxe;
    case "ionic":
      return ionic;
    case "markdown":
      return markdown;
    case "microsoft office":
      return microsoftoffice;
    case "picsart":
      return picsart;
    case "sketch":
      return sketch;
    case "unity":
      return unity;
    case "wolframalpha":
      return wolframalpha;
    case "canva":
      return canva;
    default:
      break;
  }
};
